import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { MtGroup } from "server/models"
import { deepCopy } from "client/utils"
import {
    StoreType,
    setAccountPermissionsGroupSelected,
} from "client/store"
import {
    UserIcon,
    TableColumn,
    Default,
    DateFormatter,
} from "client/components"

const Columns = (
    accountId: number,
) => {
    const selected = useSelector((state: StoreType) => state.accountPermissions.groups.selected)
    const userList = useSelector((state: StoreType) => state.user.userList)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const selectGroup = (group: MtGroup) => {
        let selectedCopy
        if (selected && selected.includes(group.id)) {
            selectedCopy = selected.filter((id) => (id !== group.id))
        } else {
            selectedCopy = selected ? deepCopy(selected) : []
            selectedCopy.push(group.id)
        }
        dispatch(setAccountPermissionsGroupSelected(selectedCopy))
    }

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            sortable: true,
            onClick: selectGroup,
        },
        {
            field: "name",
            header: lang.name,
            sortable: true,
            cellMinWidth: "200px",
            onClick: selectGroup,
        },
        {
            field: "description",
            header: lang.description,
            cellMinWidth: "200px",
            cellMaxWidth: "400px",
            onClick: selectGroup,
        },
        {
            field: "creator",
            header: lang.createdBy,
            cellWidth: "200px",
            cellMinWidth: "200px",
            formatter: (group: MtGroup) => {
                if (group.accountId !== accountId && group.accountId === 1) return <Default />

                const user = userList[group.creator]
                return <UserIcon user={user} size="sm" />
            },
            onClick: selectGroup,
        },
        {
            field: "createdAt",
            header: lang.created,
            sortable: true,
            formatter: (group: MtGroup) => <DateFormatter date={group.createdAt} />,
            onClick: selectGroup,
        },
    ]

    return columns
}
export default Columns
